import { ICancellationToken } from './cancellation-token';

export type source = 'app' | 'login' | 'maintenance' | 'commandQueue' | 'syncRegistry';

export interface ICancellationTokenHandler {
  getToken(source: source): ICancellationToken;
  setupToken(source: source): ICancellationToken;
  cancellAll(): Promise<void>;
}
